module.exports = __webpack_public_path__ + "img/balcony.c2f0cb89.svg";